import styled from 'styled-components';
import { Card, Space, Text } from 'components';

export const ContentWrapper = styled.div`
  width: 488px;
  margin: 25px auto;
  height: 70vh;
`;

export const ContentSpace = styled(Space)`
  text-align: center;
  align-items: center;
`;

export const ContactCard = styled(Card)`
  width: 470px;
  margin-top: 20px;
`;

export const TitleText = styled(Text)`
  font-weight: 600;
  font-size: 20px;
`;

export const BodyText = styled(Text)`
  font-size: 14px;
`;

export const PhoneText = styled(Text)`
  font-weight: 600;
  font-size: 38px;
`;
